import { useEffect } from "react";
import { onProjectSheetInvalidation } from "../shared/utils/projectSheetInvalidation";

export function useProjectSheetInvalidation({
  onInvalidate,
  enabled = true,
}) {
  useEffect(() => {
    if (!enabled || typeof onInvalidate !== "function") return;

    const unsubscribe = onProjectSheetInvalidation(() => {
      onInvalidate();
    });

    return unsubscribe;
  }, [onInvalidate, enabled]);
}
